import { Component, Fragment } from 'react';
import cx from 'classnames';
import TopFundList from './topFundList';
import styles from '../../styles/homePage/topFunds.scss';
import { handleTrack } from '../../utils/trackActions';

interface FundData {
  title?: string;
  subTitle?: string;
  points?: any[];
  fundType?: string;
  funds: any[];
  dataName?: string;
}

interface Props {
  startInvestment: any;
  handleRowClick: any;
  data: FundData;
  id?: string;
  hideShowMore?: boolean;
  addFundToCompare: (fundItem: any) => void;
  fundsToShow: number;
  title: string;
}

interface State {
  showMore: boolean;
}

class TopFundsSection extends Component<Props, State> {
  public state: State = {
    showMore: false,
  };

  public toggleShowMore = (e: any) => {
    const { showMore } = this.state;
    this.setState({ showMore: !showMore });
    handleTrack({ label: `top_funds_toggle_button`, obj: e.target });
  };

  private handleActionItemClick = (action: string, fundItem: any) => {
    const { startInvestment, id, addFundToCompare } = this.props;
    if (action === 'invest') {
      startInvestment(fundItem, id);
    } else if (action === 'compare') {
      addFundToCompare(fundItem);
    }
  };

  public render() {
    const { showMore } = this.state;
    const {
      startInvestment,
      data,
      id,
      hideShowMore,
      handleRowClick,
      fundsToShow,
      title,
    } = this.props;
    const { funds } = data;

    if (!funds || funds.length === 0) {
      return null;
    }

    return (
      <Fragment>
        <div>
          <TopFundList
            fundList={showMore ? funds : funds.slice(0, fundsToShow || 5)}
            handleRowClick={(item, rowId) => handleRowClick(item, rowId)}
            startInvestment={startInvestment}
            handleActionClick={this.handleActionItemClick}
            id={id}
            title={title}
          />
          <div className={styles['fund-btn-wrapper']}>
            {!hideShowMore && funds.length > (fundsToShow || 5) ? (
              <button
                onClick={this.toggleShowMore}
                className={cx(
                  styles['btn-hollow'],
                  'btn-shine text--md lil-mb-3'
                )}
              >
                {showMore ? 'Show Less' : 'Show More'}
              </button>
            ) : null}
            {showMore ? (
              <a
                onClick={(e) =>
                  handleTrack({ label: 'top_funds_button', obj: e.target })
                }
                href={`/save/search`}
                className={cx('s-btn s-btn--blue text--md btn-shine ml10')}
              >
                Explore All Mutual Funds
              </a>
            ) : null}
          </div>
        </div>
      </Fragment>
    );
  }
}
export default TopFundsSection;



// WEBPACK FOOTER //
// ./components/homePage/topFundsSection.tsx